import { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux"
import { usePbiExportFileMutation } from '../features/auth/authApiSlice'
import { selectPBIReportList, selectSelectedReportDetails, selectPBIWorkspace, selectUserPreference } from "../features/auth/authSlice"
import { selectReportId, setSubscriptionReportID, setIsEditSubscription, setFileDownloadStatus, selectFileDownloadStatus } from '../features/data/dataSlice'
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import RefreshIcon from '@mui/icons-material/Refresh';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import Spinner from './Spinner'
import AddSubscription from './addsubscription'
import { saveAs } from 'file-saver';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';


const ExportSubscribeAction = () => {
  const dispatch = useDispatch()
  const [exportEl, setExportEl] = useState(null);
  const [reportIdtoExport, setReportIdtoExport] = useState("");
  const [reportRendered, setReportRendered] = useState(0);
  const openExport = Boolean(exportEl);
  const reportEmbeddObj = useSelector(selectSelectedReportDetails)
  const reportList = useSelector(selectPBIReportList);
  const dataReportId = useSelector(selectReportId);
  const pbiworkspace = useSelector(selectPBIWorkspace)
  const downloadStatus = useSelector(selectFileDownloadStatus);
  const [downloads, setDownloads] = useState([]);

  const { locale, defaultCulture } = useSelector(selectUserPreference);

  const [pbiExportFile, { isPBIExportFileLoading }] = usePbiExportFileMutation()

  const [spinnerLoad, setSpinnerLoad] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const [openAddSubscription, setOpenAddSubscription] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const checkRenderedStatus = () => {
    const isReportRendered = JSON.parse(localStorage.getItem('reportrendered'));
    if (isReportRendered == 'true') {
      setReportRendered(1);
    } else {
      setReportRendered(0);
    }
  }


  const handleExportClick = (event) => {
    setExportEl(event.currentTarget);
    getReportIdtoExport();
    checkRenderedStatus();
  };

  const getReportIdtoExport = () => {
    const reportidlist = reportList.filter(report => report.name.includes(reportEmbeddObj.name));
    if (reportidlist.length >= 2) {
      const reportpaginatedlist = reportidlist.filter(report => report.name.toLocaleLowerCase().includes('paginated-'));
      if (reportpaginatedlist.length) {
        setReportIdtoExport(reportpaginatedlist[0].reportId)
      } else {
        setReportIdtoExport(dataReportId)
      }
    } else {
      setReportIdtoExport(dataReportId)
    }
  }

  const handleClose = () => {
    setExportEl(null);
  };

  const handleOpenAddSubscription = () => {
    dispatch(setIsEditSubscription(false))
    setOpenAddSubscription(true);
    const susbcriptionreportidlist = reportList.filter(report => report.name.includes(reportEmbeddObj.name));
    if (susbcriptionreportidlist.length >= 2) {
      const susbcriptionreportpaginated = susbcriptionreportidlist.filter(report => report.name.toLocaleLowerCase().includes('paginated-'));
      if (susbcriptionreportpaginated.length) {
        dispatch(setSubscriptionReportID(susbcriptionreportpaginated[0].reportId))
      }
    }
  }
  const handleAddSubscriptionClose = () => {
    setOpenAddSubscription(false);
    dispatch(setIsEditSubscription(false))
  }

  const handleReportFilters = data => {
    const filterarray = [];
    data.map(obj => {
      const filtername = obj.filters.length ? obj.filters[0].target.column : "";
      const filtervalue = obj.filters.length ? obj.filters[0].values : [];
      if (filtervalue.length) {
        filtervalue.map(value => filterarray.push({ "name": filtername.replace(/ /g, "_"), "value": String(value) }));
      }
    })
    return filterarray;
  }

  const handleNPPDFClick = async () => {
    try {
      setSpinnerLoad(false)
      const requetpayload = { "GroupId": pbiworkspace, "ReportId": reportIdtoExport, "fileFormat": "PDF", paginated: reportIdtoExport != dataReportId ? true : false, "locale": defaultCulture ? defaultCulture : "en-US" }
      const filename = reportEmbeddObj && reportEmbeddObj.name ? `${reportEmbeddObj.name}.pdf` : "report.pdf";
      setOpenSnackbar(true);
      const newDownload = { status: 'pending' };
      setDownloads(prevDownloads => [...prevDownloads, newDownload]);
      const response = await pbiExportFile(requetpayload);
      if (response) {
        setOpenSnackbar(true);
        setDownloads((prevDownloads) => {
          const indexOfPending = prevDownloads.findIndex(obj => obj.status === "pending");
          const updatedObjectsArray = prevDownloads.slice();
          updatedObjectsArray[indexOfPending] = {
            ...updatedObjectsArray[indexOfPending],
            status: "success"
          };
          return updatedObjectsArray;
        })
      }
      setTimeout(() => {
        const blob = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
        saveAs(blob, filename);
      }, 1000);
      setSpinnerLoad(false)

    } catch (err) {
      setOpenSnackbar(true);
      setDownloads((prevDownloads) => {
        const indexOfPending = prevDownloads.findIndex(obj => obj.status === "pending");
        const updatedObjectsArray = prevDownloads.slice();
        updatedObjectsArray[indexOfPending] = {
          ...updatedObjectsArray[indexOfPending],
          status: "error"
        };
        return updatedObjectsArray;
      })
      if (!err?.originalStatus) {
        // isLoading: true until timeout occurs
        setErrMsg('No Server Response');
      } else if (err.originalStatus === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.originalStatus === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
      // errRef.current.focus();
      setSpinnerLoad(false)
    }
  }

  const handlePDFClick = async () => {
    try {
      setSpinnerLoad(false)
      const filterReportDataLS = JSON.parse(localStorage.getItem('filterdata'));
      const filterReportData = filterReportDataLS.length ? handleReportFilters(filterReportDataLS) : [];
      const requetpayload = { "GroupId": pbiworkspace, "ReportId": reportIdtoExport, "fileFormat": "PDF", paginated: reportIdtoExport != dataReportId ? true : false, "locale": defaultCulture ? defaultCulture : "en-US", "filters": filterReportData }
      const filename = reportEmbeddObj && reportEmbeddObj.name ? `${reportEmbeddObj.name}.pdf` : "report.pdf";
      setOpenSnackbar(true);
      setDownloads(prevDownloads => [...prevDownloads, { status: 'pending' }]);
      const response = await pbiExportFile(requetpayload);
      if (response) {
        setOpenSnackbar(true);
        setDownloads((prevDownloads) => {
          const indexOfPending = prevDownloads.findIndex(obj => obj.status === "pending");
          const updatedObjectsArray = prevDownloads.slice();
          updatedObjectsArray[indexOfPending] = {
            ...updatedObjectsArray[indexOfPending],
            status: "success"
          };
          return updatedObjectsArray;
        })
      }
      setTimeout(() => {
        const blob = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
        saveAs(blob, filename);
      }, 1000);
      setSpinnerLoad(false)

    } catch (err) {
      setOpenSnackbar(true);
      setDownloads((prevDownloads) => {
        const indexOfPending = prevDownloads.findIndex(obj => obj.status === "pending");
        const updatedObjectsArray = prevDownloads.slice();
        updatedObjectsArray[indexOfPending] = {
          ...updatedObjectsArray[indexOfPending],
          status: "error"
        };
        return updatedObjectsArray;
      })
      if (!err?.originalStatus) {
        // isLoading: true until timeout occurs
        setErrMsg('No Server Response');
      } else if (err.originalStatus === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.originalStatus === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
      // errRef.current.focus();
      setSpinnerLoad(false)
    }
  }

  const renderDownloadStatusAlert = () => {
    let pending = 0;
    let success = 0;
    return downloads && downloads.length > 0 ? downloads.map((item, index) => {
      if (item.status === 'pending' && success === 0) {
        pending++;
        return <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          open={openSnackbar} autoHideDuration={5000} onClose={handleCloseAlert}>
          <Alert key={index} variant="filled" severity="info">{`${pending}/${downloads.length} Report(s) download is in progress.`}</Alert>
        </Snackbar>
      }
      if (item.status === 'success') {
        success++;
        return <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          open={openSnackbar} autoHideDuration={5000} onClose={handleCloseAlert}>

          <Alert key={index} variant="filled" severity="success">{`${success}/${downloads.length} Report(s) download is completed.`}</Alert>
        </Snackbar>
      }
      if (item.status === 'error') {
        return <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={openSnackbar} autoHideDuration={5000} onClose={handleCloseAlert}>
          <Alert key={index} variant="filled" severity="error">{`Report download failed.`}</Alert>
        </Snackbar>
      }
    }) : null;
  }

  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  useEffect(() => {
    if(downloads && downloads.length > 0 && downloads.every(obj => obj.status === 'success')) {
      setTimeout(() => {
        setDownloads([]);
      }, 5000);
    }
  }, [downloads])

  const handleExcelClick = async () => {
    try {
      setSpinnerLoad(false)
      const filterReportDataLS = JSON.parse(localStorage.getItem('filterdata'));
      const filterReportData = filterReportDataLS.length ? handleReportFilters(filterReportDataLS) : [];
      const requetpayload = { "GroupId": pbiworkspace, "ReportId": reportIdtoExport, "fileFormat": "XLSX", paginated: reportIdtoExport != dataReportId ? true : false, "locale": defaultCulture ? defaultCulture : "en-US", "filters": filterReportData }
      const filename = reportEmbeddObj && reportEmbeddObj.name ? `${reportEmbeddObj.name}.xlsx` : "report.xlsx";
      setOpenSnackbar(true);
      setDownloads(prevDownloads => [...prevDownloads, { status: 'pending' }]);
      const response = await pbiExportFile(requetpayload);
      if (response) {
        setOpenSnackbar(true);
        setDownloads((prevDownloads) => {
          const indexOfPending = prevDownloads.findIndex(obj => obj.status === "pending");
          const updatedObjectsArray = prevDownloads.slice();
          updatedObjectsArray[indexOfPending] = {
            ...updatedObjectsArray[indexOfPending],
            status: "success"
          };
          return updatedObjectsArray;
        })
      }
      setTimeout(() => {
        const blob = window.URL.createObjectURL(new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
        saveAs(blob, filename);
      }, 3000);
      setSpinnerLoad(false)

    } catch (err) {
      setOpenSnackbar(true);
      setDownloads((prevDownloads) => {
        const indexOfPending = prevDownloads.findIndex(obj => obj.status === "pending");
        const updatedObjectsArray = prevDownloads.slice();
        updatedObjectsArray[indexOfPending] = {
          ...updatedObjectsArray[indexOfPending],
          status: "error"
        };
        return updatedObjectsArray;
      })
      if (!err?.originalStatus) {
        // isLoading: true until timeout occurs
        setErrMsg('No Server Response');
      } else if (err.originalStatus === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.originalStatus === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
      // errRef.current.focus();
      setSpinnerLoad(false)
    }
  }

  const handleTxtClick = async () => {
    try {
      setSpinnerLoad(false)
      const filterReportDataLS = JSON.parse(localStorage.getItem('filterdata'));
      const filterReportData = filterReportDataLS.length ? handleReportFilters(filterReportDataLS) : [];
      const requetpayload = { "GroupId": pbiworkspace, "ReportId": reportIdtoExport, "fileFormat": "TXT", paginated: reportIdtoExport != dataReportId ? true : false, "locale": defaultCulture ? defaultCulture : "en-US", "filters": filterReportData }
      const filename = reportEmbeddObj && reportEmbeddObj.name ? `${reportEmbeddObj.name}.txt` : "report.txt";
      setOpenSnackbar(true);
      setDownloads(prevDownloads => [...prevDownloads, { status: 'pending' }]);
      const response = await pbiExportFile(requetpayload);
      if (response) {
        setOpenSnackbar(true);
        setDownloads((prevDownloads) => {
          const indexOfPending = prevDownloads.findIndex(obj => obj.status === "pending");
          const updatedObjectsArray = prevDownloads.slice();
          updatedObjectsArray[indexOfPending] = {
            ...updatedObjectsArray[indexOfPending],
            status: "success"
          };
          return updatedObjectsArray;
        })
      }
      setTimeout(() => {
        const blob = new Blob([response.data], { type: "text/plain;charset=utf-8" });
        saveAs(blob, filename);
      }, 3000);
      setSpinnerLoad(false)

    } catch (err) {
      setOpenSnackbar(true);
      setDownloads((prevDownloads) => {
        const indexOfPending = prevDownloads.findIndex(obj => obj.status === "pending");
        const updatedObjectsArray = prevDownloads.slice();
        updatedObjectsArray[indexOfPending] = {
          ...updatedObjectsArray[indexOfPending],
          status: "error"
        };
        return updatedObjectsArray;
      })
      if (!err?.originalStatus) {
        // isLoading: true until timeout occurs
        setErrMsg('No Server Response');
      } else if (err.originalStatus === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.originalStatus === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
      // errRef.current.focus();
      setSpinnerLoad(false)
    }
  }

  const handleCsvClick = async () => {
    try {
      setSpinnerLoad(false)
      const filterReportDataLS = JSON.parse(localStorage.getItem('filterdata'));
      const filterReportData = filterReportDataLS.length ? handleReportFilters(filterReportDataLS) : [];
      const requetpayload = { "GroupId": pbiworkspace, "ReportId": reportIdtoExport, "fileFormat": "CSV", paginated: reportIdtoExport != dataReportId ? true : false, "locale": defaultCulture ? defaultCulture : "en-US", "filters": filterReportData }
      const filename = reportEmbeddObj && reportEmbeddObj.name ? `${reportEmbeddObj.name}.csv` : "report.csv";
      setOpenSnackbar(true);
      setDownloads(prevDownloads => [...prevDownloads, { status: 'pending' }]);
      const response = await pbiExportFile(requetpayload);
      if (response) {
        setOpenSnackbar(true);
        setDownloads((prevDownloads) => {
          const indexOfPending = prevDownloads.findIndex(obj => obj.status === "pending");
          const updatedObjectsArray = prevDownloads.slice();
          updatedObjectsArray[indexOfPending] = {
            ...updatedObjectsArray[indexOfPending],
            status: "success"
          };
          return updatedObjectsArray;
        })
      }
      setTimeout(() => {
        const blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
        saveAs(blob, filename);
      }, 3000);
      setSpinnerLoad(false)

    } catch (err) {
      setOpenSnackbar(true);
      setDownloads((prevDownloads) => {
        const indexOfPending = prevDownloads.findIndex(obj => obj.status === "pending");
        const updatedObjectsArray = prevDownloads.slice();
        updatedObjectsArray[indexOfPending] = {
          ...updatedObjectsArray[indexOfPending],
          status: "error"
        };
        return updatedObjectsArray;
      })
      if (!err?.originalStatus) {
        // isLoading: true until timeout occurs
        setErrMsg('No Server Response');
      } else if (err.originalStatus === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.originalStatus === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
      // errRef.current.focus();
      setSpinnerLoad(false)
    }
  }


  return (
    <>
      <Button variant="contained" endIcon={<ScheduleSendIcon />} onClick={() => handleOpenAddSubscription()}>Subscribe</Button>
      <Tooltip title="Export Report">
        <Button variant="contained" sx={{ mr: 1 }} startIcon={<FileDownloadIcon />} onClick={handleExportClick} className="exportbtn" aria-controls={openExport ? 'export-menu' : undefined} aria-haspopup="true" aria-expanded={openExport ? 'true' : undefined}>Export</Button>
      </Tooltip>
      <Menu
        anchorEl={exportEl}
        id="export-menu"
        open={openExport}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {reportRendered == 1 && (
          <>
            {(reportIdtoExport == dataReportId) && (
              <MenuItem onClick={handleNPPDFClick}>
                <ListItemIcon>
                  <PictureAsPdfIcon fontSize="small" />
                </ListItemIcon>
                PDF
              </MenuItem>
            )}
            {(reportIdtoExport != dataReportId) && (
              <>
                <MenuItem onClick={handlePDFClick}>
                  <ListItemIcon>
                    <PictureAsPdfIcon fontSize="small" />
                  </ListItemIcon>
                  PDF
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleExcelClick}>
                  <ListItemIcon>
                    <BackupTableIcon fontSize="small" />
                  </ListItemIcon>
                  EXCEL
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleTxtClick}>
                  <ListItemIcon>
                    <BackupTableIcon fontSize="small" />
                  </ListItemIcon>
                  TEXT
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleCsvClick}>
                  <ListItemIcon>
                    <BackupTableIcon fontSize="small" />
                  </ListItemIcon>
                  CSV
                </MenuItem>
              </>
            )}
          </>
        )}
        {reportRendered == 0 && (
          <MenuItem>
            Report yet to render...
            <RefreshIcon onClick={checkRenderedStatus} />
          </MenuItem>
        )}
      </Menu>
      {renderDownloadStatusAlert()}
      {spinnerLoad && (<Spinner />)}
      <AddSubscription openAddSubscription={openAddSubscription} handleAddSubscriptionClose={handleAddSubscriptionClose} />
    </>
  );
};

export default ExportSubscribeAction;
